import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import { Card, Col, Row, Tabs, Tab } from 'react-bootstrap';

import { fetchEpstScoreSheetByCertification, updateEpstScoreCertificationSection } from 'api/certifications/epst/results';

import { handleApiError, successNotification } from 'utils';

import styles from './epstEvaluation.module.scss';
import WritingQuestion from './WritingQuestion';
import SpeakingQuestion from './SpeakingQuestion';

const EvaluationEpst = () => {
	const token = useSelector(state => state.authentication.user?.token);

	const location = useLocation();
	const navigate = useNavigate();
	const { certification } = location.state || {};

	const [writings, setWritings] = useState([]); 
	const [speakings, setSpeakings] = useState([]); 

	const [activeTab, setActiveTab] = useState("writing");

	const [writingEvaluations, setWritingEvaluations] = useState([]);
	const [speakingEvaluations, setSpeakingEvaluations] = useState([]);

	useEffect(() => {
		if (!certification.id) navigate(-1);
		else {
			loadCertificationByIdSectionId(4);
			loadCertificationByIdSectionId(5); 
		}
	}, [certification, navigate]);

	const loadCertificationByIdSectionId = async (sectionId) => {
		try {
			const { data } = await fetchEpstScoreSheetByCertification(certification.id, sectionId, token);
			if(sectionId === 4) setWritings(data.message);
			else if(sectionId === 5) setSpeakings(data.message);
		} catch (error) {
			handleApiError(error);
		}
	}

	const handleUpdateEpstScoreCertificationSection = async (payload) => {
		try {
			const { data } = await updateEpstScoreCertificationSection(certification.id, payload, token);
			if(data.status === 200) successNotification("Seccion Evaluado Correctamente");
		} catch (error) {
			handleApiError(error);
		}
	}

	// Guarda los cambios de cada pregunta
	const handleWritingScoreChange = (question_id, score, earnedPoints) => {
		setWritingEvaluations(prev => {
			const updated = prev.filter(item => item.question_id !== question_id);
			return [...updated, { question_id, score, earned_points: earnedPoints }];
		});
	};

	// Función para enviar al backend
	const handleSubmitWriting = async () => {
		const totalEarnedPoints = writingEvaluations.reduce(
			(acc, item) => acc + (item.earned_points || 0), 0
		);
		let payload = {
			section_id: 4,
			score: totalEarnedPoints
		}
		handleUpdateEpstScoreCertificationSection(payload);
	};

	const handleSpeakingScoreChange = (question_id, score, earned_points) => {
		setSpeakingEvaluations(prev => {
			const updated = prev.filter(item => item.question_id !== question_id);
			return [...updated, { question_id, score, earned_points }];
		});
	};
	
	const handleSubmitSpeaking = async () => {
		const totalEarnedPoints = speakingEvaluations.reduce(
			(acc, item) => acc + (item.earned_points || 0), 0
		);
		let payload = {
			section_id: 5,
			score: totalEarnedPoints
		}
		handleUpdateEpstScoreCertificationSection(payload);
	};



	return (
		<Card>
			<Card.Body className="overflow-hidden p-lg-5">
				<h5 className="text-primary">Calificar Certificación</h5>

				{/* Información general */}
				<Row className="mt-3">
					{/* Columna izquierda */}
					<Col xs={12} md={6}>
						<p className={styles.rowUserData}>
							<strong>Nombre:</strong> {certification.name}
						</p>
						<p className={styles.rowUserData}>
							<strong>Email:</strong> {certification.email}
						</p>
						<p className={styles.rowUserData}>
							<strong>Colegio:</strong> {certification.college_name}
						</p>
					</Col>

					{/* Columna derecha */}
					<Col xs={12} md={6}>
						<p className={styles.rowUserData}>
							<strong>Tipo usuario:</strong> {certification.candidate_type}
						</p>
						<p className={styles.rowUserData}>
							<strong>Tipo certificación:</strong> {certification.certification_type}
						</p>
						<p className={styles.rowUserData}>
							<strong>Fecha finalizado:</strong> {certification.completed_date}
						</p>
					</Col>
				</Row>
				{/* Tabs para Writing y Speaking */}
				<Tabs 
					defaultActiveKey="writing"
					activeKey={activeTab}
					onSelect={(k) => setActiveTab(k)}
					className="mb-3 mt-3">
					{/* Writing Tab */}
					<Tab eventKey="writing" title="Writing" className="p-3">
						{writings.length === 0 ? (
							<Row><Col>No hay respuestas para esta sección.</Col></Row>
						) : (
							<>
								{writings.map(question => (
									<WritingQuestion
										key={question.question_id}
										questionData={question}
										onScoreChange={handleWritingScoreChange}
									/>
								))}
							</>
						)}
					</Tab>

					{/* Speaking Tab */}
					<Tab eventKey="speaking" title="Speaking" className="p-3">
						{speakings.length === 0 ? (
							<Row><Col>No hay respuestas para esta sección.</Col></Row>
						) : (
							<>
								{speakings.map(question => (
									<SpeakingQuestion
										key={question.question_id}
										questionData={question}
										onScoreChange={handleSpeakingScoreChange}
									/>
								))}
							</>
						)}
					</Tab>
				</Tabs>
				<div className="d-flex justify-content-between" >
					<button className="btn btn-outline-secondary" onClick={() => navigate(-1)}>
						← Regresar
					</button>
					<button
						className="btn btn-primary"
						onClick={activeTab === "writing" ? handleSubmitWriting : handleSubmitSpeaking}
					>
						Guardar evaluación
					</button>
				</div>

			</Card.Body>
		</Card>
	);
};

export default EvaluationEpst;